import styled from 'styled-components'
import { Box } from 'src/components'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

export const CallToAction = styled(motion(Box))`
    min-width: 157px;
    height: 37.33px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-width: 177px;
        height: 37.33px;
    }
`
export const LinkButton = styled(motion(Link))`
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
